(function () {
  const DISCOUNT_PROPERTY = '_shopify_discount';
  const root = window.Shopify?.routes?.root || '/';

  const pendingRequests = new Map();

  window.addEventListener('klaviyoForms', handleKlaviyoFormEvent);

  function handleKlaviyoFormEvent(event) {
    const detail = event.detail || {};
    const formId = detail.formId || detail.formID;

    if (!formId) return;

    if (detail.type === 'stepSubmit') {
      handleStepSubmit(formId, detail);
      return;
    }

    if (detail.type === 'close') {
      handlePopupClose(formId);
    }
  }

  function handleStepSubmit(formId, detail) {
    const metaData = detail.metaData || {};

    const email = String(
      metaData.$email ||
      metaData.email ||
      ''
    ).trim();

    const discountCode = String(
      metaData[DISCOUNT_PROPERTY] ||
      ''
    ).trim();

    // Ignore SMS step and all Klaviyo forms
    // that don't have the discount hidden property
    if (!email || !discountCode) {
      return;
    }

    if (pendingRequests.has(formId)) {
      return;
    }

    const discountPromise = applyDiscount(discountCode);

    pendingRequests.set(formId, discountPromise);

    discountPromise.catch((error) => {
      console.error(
        '[Klaviyo Discount] Failed to apply discount',
        error
      );
    });
  }

  async function applyDiscount(discountCode) {
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      credentials: 'same-origin',
      cache: 'no-store',

      body: JSON.stringify({
        discount: discountCode
      })
    });

    let cart;

    try {
      cart = await response.json();
    } catch (error) {
      throw new Error(
        `Unable to parse Shopify cart response (${response.status})`
      );
    }

    if (!response.ok) {
      throw new Error(
        cart.description ||
        cart.message ||
        `Shopify cart update failed with status ${response.status}`
      );
    }

    console.log(
      '[Klaviyo Discount] Discount applied:',
      discountCode
    );

    return {
      discountCode,
      cart,
      shouldReload: Number(cart.item_count) > 0
    };
  }

  async function handlePopupClose(formId) {
    const discountPromise = pendingRequests.get(formId);

    if (!discountPromise) return;

    try {
      const result = await discountPromise;

      pendingRequests.delete(formId);

      if (result.shouldReload) {
        window.location.reload();
      }
    } catch (error) {
      pendingRequests.delete(formId);

      console.error(
        '[Klaviyo Discount] Reload skipped because discount request failed',
        error
      );
    }
  }
})();